
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"21","viewBox":"0 0 20.871 20.871"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Сгруппировать 22570"}},[_c('g',{attrs:{"data-name":"Сгруппировать 22569"}},[_c('path',{attrs:{"data-name":"Контур 547","d":"M17.725 3.145a10.31 10.31 0 00-14.58 14.58 10.31 10.31 0 0014.58-14.58zm-7.29 16.392a9.1 9.1 0 119.1-9.1 9.112 9.112 0 01-9.1 9.1z","fill":"#fff","stroke":"#fff","stroke-width":".25"}})])]),_c('g',{attrs:{"data-name":"Сгруппировать 22572"}},[_c('g',{attrs:{"data-name":"Сгруппировать 22571"}},[_c('path',{attrs:{"data-name":"Контур 548","d":"M11.083 9.832H9.789a1.337 1.337 0 110-2.674h2.588a.604.604 0 000-1.208H11.04V4.612a.604.604 0 10-1.208 0v1.337h-.043a2.546 2.546 0 100 5.091h1.294a1.337 1.337 0 010 2.674H8.495a.604.604 0 100 1.208h1.337v1.337a.604.604 0 101.208 0v-1.337h.043a2.546 2.546 0 000-5.091z","fill":"#fff","stroke":"#fff","stroke-width":".25"}})])])])
          )
        }
      }
    